// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"39b05a08","410":"f035d35e","412":"cba0be46","823":"513ae81e"}[chunkId] + ".chunk.js";
};